import axios from '@/services/axios';
import { useOrganization } from '@clerk/clerk-react';

export const useMembersApi = () => {
  const { organization } = useOrganization();

  const getMembers = async (params = {}) => {
    const { data } = await axios.get('/user/profile/members', {
      params: {
        orgId: organization?.id,
        page: 1,
        limit: 100,
        ...params,
      },
    });
    return data.data.members || [];
  };

  const addMember = async (memberData) => {
    const members = Array.isArray(memberData) ? memberData : [memberData];
    const apiData = {
      orgId: organization?.id,
      members: members,
      role: members[0]?.role || 'member',
    };

    const { data } = await axios.post('/user/profile/add-members', apiData);
    return {
      success: true,
      data: data.data,
      message: data.message || 'Member added successfully',
    };
  };

  return { getMembers, addMember };
};
